"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = exports.ErrorBoundaryWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
exports.ErrorBoundaryWrapper = styled_components_1.default.div `
  padding: 96px 40px 20px;
  height: 100%;
`;
exports.ErrorMessage = (0, styled_components_1.default)(material_1.Typography) `
  margin-top: 24px;
  font-weight: 700;
`;
